import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const DASHBOARD_URL = `${API_URL}/kpi/dashboard`

export const fetchDataDashboard = (dateInit, dateEnd, franchise): Promise<any> => {
  const params = new URLSearchParams()
  if (dateInit) params.append('dtstart', dateInit)
  if (dateEnd) params.append('dtend', dateEnd)
  if (franchise.length) params.append('franchises', franchise)
  return axios
    .get(`${DASHBOARD_URL}${params.toString() ? `?${params.toString()}` : ''}`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}
